export interface IBusinessUnit {
  type:
    | 'axi'
    | 'align-link'
    | 'chemical-compliance'
    | 'dso'
    | 'exocad'
    | 'invisalign'
    | 'itero'
    | 'reseller'
    | 'tps'
    | 'service';
}

export const databaseConnectionMap: Record<IBusinessUnit['type'], string> = {
  axi: 'axi-db',
  'align-link': 'align-link-db',
  'chemical-compliance': 'chemical-supplier-db',
  dso: 'dso-db',
  exocad: 'exocad-users-db',
  invisalign: 'align-db',
  itero: 'itero-db',
  reseller: 'orion-db',
  tps: 'align-db',
  service: 'service-account-db',
};

export const parseCallbackUrlForBusinessUnit = (
  url: string,
): IBusinessUnit['type'] | '' =>
  /dso/.test(url)
    ? 'dso'
    : /reseller/.test(url)
    ? 'reseller'
    : /axi/.test(url)
    ? 'axi'
    : /invisalign/.test(url)
    ? 'invisalign'
    : /itero/.test(url)
    ? 'itero'
    : /exocad/.test(url)
    ? 'exocad'
    : /chemical-compliance/.test(url)
    ? 'chemical-compliance'
    : /align-link/.test(url)
    ? 'align-link'
    : /tps/.test(url)
    ? 'tps'
    : '';

export const clientDisplayNameMap: Record<IBusinessUnit['type'], string> = {
  axi: 'AXI Partner Portal',
  'align-link': 'Align Link',
  'chemical-compliance': 'Supplier Chemical Compliance',
  dso: 'Align Special Markets Portal',
  exocad: 'my.exocad',
  invisalign: 'Invisalign® Doctor Site',
  itero: 'iTero®',
  reseller: 'exocad Partner Portal',
  service: 'Service Account',
  tps: 'Invisalign® Doctor Site',
};
